module.exports = __webpack_public_path__ + "img/tarj2-6.6554f0b3.png";